export function generateCustomId() {
    return Math.floor(Math.random() * Date.now()).toString(14);
}
//# sourceMappingURL=generate-custom-id.js.map